import React, { useState } from 'react';
import './InputPoint.scss';
import { useTranslation } from 'react-i18next';

interface InputPointProps {
  value: number;
  onChange: (value: number) => void;
  title?: boolean;
}

const InputPoint: React.FC<InputPointProps> = ({ value, onChange, title = false }) => {
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState(value.toString());

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;

    if (/^\d*$/.test(rawValue)) {
      setInputValue(rawValue);
    }
  };

  const handleBlur = () => {
    let newValue = Number(inputValue);

    if (isNaN(newValue) || newValue < 1) newValue = 1;
    if (newValue > 100) newValue = 100;

    setInputValue(newValue.toString());
    onChange(newValue);
  };

  return (
    <div className="pointWrapper">
      <p>{title ? t('resultPointTitle') : t('pointTitle')}</p>
      <div className="input-point">
        <button
          type="button"
          className="btn-decrease"
          onClick={() => {
            const newValue = Math.max(1, value - 1);
            setInputValue(newValue.toString());
            onChange(newValue);
          }}
        >
          −
        </button>
        <input type="text" className="input-box" value={inputValue} onChange={handleChange} onBlur={handleBlur} />
        <button
          type="button"
          className="btn-increase"
          onClick={() => {
            const newValue = Math.min(100, value + 1);
            setInputValue(newValue.toString());
            onChange(newValue);
          }}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default InputPoint;
